
define('known/collections/productCollection',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/productModel'
], function($, _, Backbone, ProductModel){
	var ProductCollection = Backbone.Collection.extend({
		//model : draftApp.model.Product,
		model : ProductModel,
		userName : null, //Populate this on construction
	
		url: function() {
			return '/draftapp/users/' + this.userName + '/products';
		},
		
		initialize: function(models, options) {
			this.userName = options.userName;
			this.on('userChange', this.updateProducts);
	    },
	    
	    parse: function(resp, options) {
	    	if(resp){
		    	for(var i = 0; i < resp.length; i++) {
					if(resp[i].sport && resp[i].year){
						resp[i].id = resp[i].sport.toUpperCase() + resp[i].year;
					}
				}
	    	}
		    	
	    	return resp;
	    },
	    
	    updateProducts: function(){
	    	this.fetch({merge:true, parse: true});
	    },
	    
	    /*parse: function(data) {
	    	if (!data) {
	        	return []; 
	        }
	    	
	    	var prods = _(data).map(
	    		function(prodData) {
	    			var prod = {};
	    			prod.id = prodData.products[0].id;
	    			prod.sport = prodData.sport;
	    			prod.year = prodData.year;
	    			prod.prodName = prodData.products[0].prodName;
	    			prod.prodDesc = prodData.products[0].prodDesc;
	    			prod.price = prodData.products[0].price;
	    			prod.effDate = prodData.products[0].effDate;
	    			prod.expDate = prodData.products[0].expDate;
	    			prod.purchased = prodData.products[0].purchased;
	    			prod.active = prodData.products[0].active;
	    			return prod;
	    		}
	    	);
	    	
	    	return prods;
		},*/
	    
	    retrieveProdWithProdTypeId: function(prodTypeId) {
	    	this.foundProd = null;
	    	this.prodTypeId = prodTypeId;
	    	
	    	this.each(function(prod) {
	    		var foundProdType = prod.get("productTypes").get(this.prodTypeId);
	    		if(foundProdType){
	    			this.foundProd = prod;
	    		}
			}, this);
	    	
	    	var returnObj = this.foundProd;
	    	delete this.foundProd;
	    	delete this.prodTypeId;
	    	return returnObj;
	    },
	
	    activeProducts : function() {
	    	return this.filter(function(prod) {
				return _.size(prod.activeProducts()) > 0;
			});
		},
	    
	    activeUsableProducts : function() {
	    	return this.filter(function(prod) {
				return _.size(prod.activeUsableProducts()) > 0;
			});
		},
		
		activePurchasedProducts : function() {
			return this.filter(function(prod) {
				return _.size(prod.activePurchasedProducts()) > 0;
			});
		},
		
		activePurchasableProducts : function() {
			return this.filter(function(prod) {
				return _.size(prod.activePurchasableProducts()) > 0;
			});
		},
	    
		// Return all purchased products
		/*purchased : function() {
			return this.filter(function(prod) {
				return prod.get('purchased') == true;
			});
		},
		
		activeProducts : function() {
			return this.filter(function(product) {;
				return product.get('active');
			});
		},
		
		purchasedActiveProducts : function() {
			return this.filter(function(product) {;
				return product.get('purchased') && product.get('active');
			});
		},
		
		notPurchasedActiveProducts : function() {
			return this.filter(function(product) {;
				return !product.get('purchased') && product.get('active');
			});
		},*/
	
		//Sort by a predetermined ranking of sports: NFL, MLB, NHL, NBA
		comparator : function(prod, compProd) {
			if(prod.get('sport') == compProd.get('sport')){
				if(prod.get('year') > compProd.get('year')){
					return -1;
				} else {
					return 1;
				}
			}
			
			
			if(prod.get('sport') == 'NFL'){
				return -1;
			} else if (prod.get('sport') == 'MLB' && compProd.get('sport') != 'NFL'){
				return -1;
			} else if (prod.get('sport') == 'NHL' && compProd.get('sport') != 'NFL' && compProd.get('sport') != 'MLB') {
				return -1;
			} else {
				return 1;
			}
		}
		
	});
	
	return ProductCollection;  
});